<template>
  <div ref="chart"></div>
</template>

<script>
import ApexCharts from 'apexcharts';
export default {
  name: 'BegleitfahrtResultatChart',
  components: {},
  mixins: [],
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    chartLabels: {
      type: Array,
      required: true,
    },
    chartColors: {
      type: Array,
      required: false,
    },
    chartOptions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.chart = new ApexCharts(this.$refs.chart, this.getChartOptions());
    this.chart.render();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.destroy();
  },
  methods: {
    getChartOptions() {
      return {
        ...this.chartOptions,
        labels: this.chartLabels,
        colors: this.chartColors,
        series: this.chartData,
        legend: {
          position: 'bottom',
        },
      };
    },
  },
};
</script>
